<template>
  <div class="result">
    <div class="result-warpper">
      <h1>{{ pageInfo.title }}</h1>
      <div class="link">
        {{ 1 }}、<a :href="pageInfo.btns[0].url">{{ pageInfo.btns[0].text }}</a>
      </div>
      <div class="img-warpper">
        <img :src="pageInfo.imageUrl" alt="" />
      </div>
      <div class="link">
        {{ 2 }}、<a :href="pageInfo.btns[1].url">{{ pageInfo.btns[1].text }}</a>
      </div>
    </div>
    <div class="footer">
      <!-- <span class="btn" @click="initTocken">再次验证</span> -->
      <a
        class="btn"
        v-for="(item, key) in pageInfo.footer"
        :key="key"
        :href="item.url"
        >{{ item.text }}</a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      src: "",
      baseUrl: "http://ksy7.cn/images/",
      webpath: "http://ksy7.cn/wxapi/getWxSign",
      pageInfo: {
        title: '防伪特征',
        imageUrl: '',
        btns: [{ url: '/#/video?flag=0', text: '纤维图像对比' }, { url: '/#/video?flag=2', text: '纤维感官特征' }],
        footer: [{ url: './', text: '返回' }, { url: './', text: '再次验证' }, { url: './', text: '鉴定中心' }]
      }
    }
  },
  mounted: function () {
    this.pageInfo.imageUrl = this.baseUrl + this.$route.params.code + ".jpg";
    console.log(this.$route.params.code);
  },
  methods: {
    trueClick: function () {
      this.$router.push({ path: "/jt" })
    },
    falseClick: function () {
      this.$router.push({ path: "/jf" })
    },
    explain: function () {
      this.$router.push({ path: "/explain2" })
    },
    initTocken: function () {
      var that = this;
      var sign = "";
      $.ajax({
        debug: true,
        type: "get",
        url: that.webpath,
        async: false,
        cache: false,
        timeout: 60000,
        scriptCharset: "utf-8",
        data: { url: location.href.split('#')[0] },
        success: function (sign) {
          console.log(sign)
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: sign.appid, // 必填，公众号的唯一标识
            timestamp: sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: sign.noncestr, // 必填，生成签名的随机串
            signature: sign.signature,// 必填，签名，见附录1
            jsApiList: ['getLocation', 'chooseImage', 'uploadImage', 'previewImage', 'downloadImage', 'scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
            console.log('wxsuccess');
            wx.scanQRCode({
              needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                // console.log(res);
                // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                // console.log(result);
                // var code = result.substring(result.lastIndexOf("/") + 1);
                // console.log(code);
                // this.$router.push({ path: '/result', query: { id: code } });
              }
            });
          });
          wx.error(function (res) {
            console.error(res)
          });
        },
        error: function (err) {

        }
      });

    }
  }
}
</script>

<style  lang="scss" scoped>
.result {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;

  .result-warpper {
    // padding: 1.388889rem 0.555556rem;
    box-sizing: border-box;
    width: 100%;
    min-height: 100%;
    padding-bottom: 2.666667rem;
    h1 {
      font-size: 0.64rem;
      text-align: center;
      padding: 1rem 0;
    }
    .link {
      font-size: 0.44rem;
      padding: 16px 0;
      text-align: center;
      a {
        color: #009fe8;
        text-decoration: none;
      }
    }
    .img-warpper {
      text-align: center;

      margin: 0.555556rem auto;
      img {
        width: 80%;
      }
    }

    .tip {
      font-size: 0.444444rem;
      text-align: center;
      line-height: 0.777778rem;
    }

    .yn {
      display: flex;
      margin-top: 0.833333rem;

      .left,
      .right {
        flex: 1;
        text-align: center;
        line-height: 0.777778rem;
        font-size: 0.5rem;

        img {
          width: 0.555556rem;
          vertical-align: middle;
          margin-top: -0.055556rem;
        }

        .true,
        .false {
          font-weight: 600;
          font-size: 0.444444rem;
          font-weight: bold;
        }

        &.left .true {
          color: #009fe8;
        }

        &.right .false {
          color: #dd524d;
        }
      }
    }

    .pic {
      text-align: center;

      img {
        width: 4rem;
        margin-top: 0.555556rem;
      }
    }

    .explain {
      text-align: center;
      margin-top: 0.533333rem;

      h2 {
        font-size: 0.426667rem;
        margin-top: 0.8rem;
      }

      .btn {
        font-size: 0.5rem;
        color: #009fe8;
        border-bottom: 1px solid #009fe8;
        padding: 3px;
      }
    }
  }

  .footer {
    text-align: center;
    margin-top: -1.333333rem;
    width: 100%;
    display: flex;
    .btn {
      text-align: center;
      flex: 1;
      font-size: 0.5rem;
      color: #009fe8;
      // border-bottom: 1px solid #009fe8;
      padding: 3px;
      text-decoration: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/result.vue